const config = {
  headers: {
    api_token: localStorage.getItem("api-token"),
    Authorization: JSON.parse(localStorage.getItem("userdata"))?.hash_id,
    "App-Language": localStorage.getItem("language") || "en",
  },
};

export default config;
